/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Continue_AnywayInputs */

const en_dialog_text_to_audio_continue_anyway = /** @type {(inputs: Dialog_Text_To_Audio_Continue_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continue anyway`)
};

const es_dialog_text_to_audio_continue_anyway = /** @type {(inputs: Dialog_Text_To_Audio_Continue_AnywayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Continuar de todos modos`)
};

/**
* | output |
* | --- |
* | "Continue anyway" |
*
* @param {Dialog_Text_To_Audio_Continue_AnywayInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_continue_anyway = /** @type {((inputs?: Dialog_Text_To_Audio_Continue_AnywayInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Continue_AnywayInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_continue_anyway(inputs)
	return en_dialog_text_to_audio_continue_anyway(inputs)
});